import { InfoSection } from "./index.tsx";
import { useSectionsData } from "../../utils/useSectionsData";
import { getInfoSectionData } from "../../utils/helpers";
import { ReactNode } from "react";

interface InfoSectionWrapperProps {
  sectionKey: string;
  lineComponent?: ReactNode;
}

export const InfoSectionWrapper = ({
  sectionKey,
  lineComponent,
}: InfoSectionWrapperProps) => {
  const sections = useSectionsData();
  const sectionData = getInfoSectionData(sections, sectionKey);

  return (
    <InfoSection
      title={sectionData.tr_heading}
      description={sectionData.tr_description}
      htmlDescription={true}
      lineComponent={lineComponent}
      progressBarLabel={sectionData.tr_progress_bar_label}
      barPercent={sectionData.bar_percent}
    />
  );
};
